import React from "react";
import { withShowIf } from "../../../../../../../../../../components/with-show-if/with-show-If.component";
import { FlyerDetailPageDetailPositionLabel } from "../../styles/flyer-detail-page-preview-cell.styles";
import { HostContainer } from "./flyer-detail-page-preview-position-lifestyle.styles";

export const FlyerDetailPagePreviewPositionLifestyle = withShowIf(() => (
  <HostContainer>
    <FlyerDetailPageDetailPositionLabel>Lifestyle</FlyerDetailPageDetailPositionLabel>
  </HostContainer>
));
